<script lang="ts">
	import RoundVerified from 'virtual:icons/ic/round-verified';
	import CloseCircle from 'virtual:icons/ion/close-circle';
	import { fade } from 'svelte/transition';
	import RoundInfo from 'virtual:icons/ic/round-info';
	import type { CenterNotifType } from '@lib/types';

	export let isShow = false,
		message = '',
		type: CenterNotifType = 'success',
		duration = 3000;

	$: if (isShow) setTimeout(() => (isShow = false), duration);
</script>

{#if isShow}
	<div
		transition:fade={{ duration: 350 }}
		class="fixed left-2/4 top-2/4 z-[9999] w-full max-w-56 -translate-x-2/4 -translate-y-2/4 rounded-xl bg-gray-900/50 p-5 text-center font-medium text-base-100 shadow-soft backdrop-blur-sm"
	>
		{#if type === 'success'}
			<RoundVerified class="mx-auto mb-2.5 text-4xl" />
		{:else if type === 'error'}
			<CloseCircle class="mx-auto mb-2.5 text-4xl" />
		{:else if type === 'info'}
			<RoundInfo class="mx-auto mb-2.5 text-4xl" />
		{/if}
		<p class="text-balance text-sm">{message}</p>
	</div>
{/if}
